import { MagicConfigMixin, isTextSelected, isSpecialKey, isNumericKey } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let NumberComponent = class extends Mixins(MagicConfigMixin) {
  get pattern() {
    const { pattern } = this.$attrs;
    if (pattern) {
      return pattern;
    }
    return "\\d*";
  }
  getValue(event) {
    const target = this.getRealTarget(event);
    const currValue = target.value || "";
    const value = event.key ? event.key : `${currValue}${String.fromCharCode(event.keyCode % 48 + 48)}`;
    if (target.selectionStart !== target.selectionEnd) {
      const valueAsArray = currValue.split("");
      valueAsArray.splice(target.selectionStart, target.selectionEnd, value);
      return parseInt(valueAsArray.join(""), 10);
    }
    return parseInt(value, 10);
  }
  isInRange(value) {
    if (this.$attrs.min && this.$attrs.max) {
      const min = parseInt(this.$attrs.min, 10);
      const max = parseInt(this.$attrs.max, 10);
      return value >= min && value <= max;
    }
    return true;
  }
  onKeyDown(event) {
    if (event.isComposing || event.keyCode === 229) {
      return;
    }
    const target = this.getRealTarget(event);
    const currValue = target.value || "";
    const maxLength = this.$attrs.maxlength ? parseInt(this.$attrs.maxlength, 10) : -1;
    const isFieldComplete = currValue.length === maxLength && !isTextSelected(currValue);
    const value = this.getValue(event);
    if (!isSpecialKey(event) && (!isNumericKey(event) || !this.isInRange(value) || isFieldComplete)) {
      event.preventDefault();
    }
  }
  getRealTarget(event) {
    if (!event.composedPath) {
      return event.target;
    }
    const path = event.composedPath();
    return path[0];
  }
};
NumberComponent = __decorateClass([
  Component({
    name: "ui-number",
    inheritAttrs: true
  })
], NumberComponent);

export default NumberComponent;
